var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Object3D',{on:{"element":(v) => { _vm.root = v; _vm.init() }}})
}
var staticRenderFns = []

export { render, staticRenderFns }